/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputText from './InputText';
import { ReactComponent as EyeOn } from '../../assets/images/svg/eye-on.svg';
import { ReactComponent as EyeOff } from '../../assets/images/svg/eye-off.svg';
import { IconButton } from '../IconButton/IconButton';
import themeColors from '../../assets/styles/themeColors';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  button {
    position: absolute;
    top: 32px;
    right: 0;
    margin: 12px;
  }

  svg {
    width: 24px;
    height: 24px;
    color: ${themeColors.colorSvgSemidark};
  }

  input {
    padding-right: 42px;
  }
`;

const PasswordInput = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Container>
      <InputText
        {...props}
        type={isVisible ? 'text' : 'password'}
        maxLength="49"
      />
      <IconButton
        title={`${isVisible ? 'Hide Password' : 'Show Password'}`}
        type="button"
        onClick={() => setIsVisible(!isVisible)}
      >
        {isVisible ? <EyeOn /> : <EyeOff />}
      </IconButton>
    </Container>
  );
};

PasswordInput.propTypes = {};

export default PasswordInput;
